const basePath = "infrastructure-environmental-systems/";

export const coolingHvac = {
  id: 10,
  category: "Cooling & HVAC",

  filters: {
    Brand: { type: "checkbox" },
    Type: { type: "checkbox" },
    Capacity: { type: "checkbox" },
    Features: { type: "checkbox" },
    Sizes: { type: "checkbox" },
    Coverage: { type: "checkbox" },
    "Heat Removal": { type: "checkbox" },
  },

  subcategories: [
    {
      name: "CRAC Units (Computer Room Air Conditioners)",
      bestSeller: true,
      image: `${basePath}CRAC_Units_(Computer_Room_Air_Conditioners).png`,
      details: {
        Brand: "APC/Liebert/Eaton",
        Type: "CRAC (Chilled Water)",
        Capacity: "5-100 kW cooling",
        Features: "Humidity control, precision cooling",
      },
      about: `
        <ul>
          <li>Precision air conditioning units using chilled water for data center cooling.</li>
          <li>Provide simultaneous temperature and humidity control.</li>
        </ul>
      `,
    },
    {
      name: "CRAH Units (Computer Room Air Handlers)",
      bestSeller: true,
      image: `${basePath}CRAH_Units_(Computer_Room_Air_Handlers).png`,
      details: {
        Brand: "Mitsubishi/Fujitsu/Vertiv",
        Type: "CRAH (Air-Cooled)",
        Capacity: "3-50 kW cooling",
        Features: "Direct air-cooling, variable speed fans",
      },
      about: `
        <ul>
          <li>Air-cooled computer room air handlers using direct air exchange.</li>
          <li>Suitable for facilities with free cooling or outside air availability.</li>
        </ul>
      `,
    },
    {
      name: "In-Row Cooling Systems",
      bestSeller: true,
      image: `${basePath}In-Row_Cooling_Systems.png`,
      details: {
        Brand: "Schneider/Vertiv/APC",
        Type: "In-Row Cooler",
        Capacity: "5-25 kW per unit",
        Features: "Hot-aisle containment, modular",
      },
      about: `
        <ul>
          <li>Compact cooling units installed within equipment rows for targeted cooling.</li>
          <li>Highly efficient; reduces hot-aisle/cold-aisle mixing.</li>
        </ul>
      `,
    },
    {
      name: "Rear-Door Heat Exchangers",
      bestSeller: true,
      image: `${basePath}Rear-Door_Heat_Exchangers.png`,
      details: {
        Brand: "APC/Geist/Vertiv",
        Type: "Rear-Door Heat Exchanger",
        Capacity: "5-50 kW per door",
        Features: "Passive, no fans, silent operation",
      },
      about: `
        <ul>
          <li>Passive heat exchangers mounted to rack rear doors for hot-aisle cooling.</li>
          <li>Operate silently without fans; use facility chilled water.</li>
        </ul>
      `,
    },
    {
      name: "Chillers (Water Cooling Systems)",
      bestSeller: false,
      image: `${basePath}Chillers_Water_Cooling_Systems.svg`,
      details: {
        Brand: "Trane/Carrier/Daikin",
        Type: "Water-cooled Chiller",
        Capacity: "50-500 kW cooling",
        Features: "Precision cooling, scalable",
      },
      about: `
        <ul>
          <li>Large-scale water cooling systems for enterprise data centers.</li>
          <li>Support distributed in-row cooling, CRAC, and heat exchangers.</li>
        </ul>
      `,
    },
    {
      name: "HVAC Ducting & Distribution",
      bestSeller: false,
      image: `${basePath}HVAC_Ducting_&_Distribution.png`,
      details: {
        Brand: "Generic/Thermal Products",
        Type: "Sheet Metal/Flex Ducting",
        Sizes: "4-24 inch diameter",
        Features: "Insulated, sealed, modular",
      },
      about: `
        <ul>
          <li>Metal and flexible ducting for distributing conditioned air within facilities.</li>
          <li>Essential for hot/cold aisle containment strategies.</li>
        </ul>
      `,
    },
    {
      name: "Raised-Floor Cooling Systems",
      bestSeller: true,
      image: `${basePath}Raised-Floor_Cooling_Systems.png`,
      details: {
        Brand: "Schneider/APC/Vertiv",
        Type: "Raised-Floor Plenum Air Distribution",
        Coverage: "Modular per facility size",
        Features: "Scalable, hot/cold aisle support",
      },
      about: `
        <ul>
          <li>Underneath-the-floor air distribution systems commonly used in legacy data centers.</li>
          <li>Enables efficient hot-aisle/cold-aisle strategies.</li>
        </ul>
      `,
    },
    {
      name: "Liquid Cooling Racks & Panels",
      bestSeller: false,
      image: `${basePath}Liquid_Cooling_Racks_Panels.svg`,
      details: {
        Brand: "LiquidCool/3M/Asetek",
        Type: "Direct-to-Chip/Immersion Cooling",
        "Heat Removal": "10-100+ kW per rack",
        Features: "High-efficiency, compact",
      },
      about: `
        <ul>
          <li>Next-generation liquid cooling solutions for high-density server environments.</li>
          <li>Direct-to-chip or immersion cooling for extreme density deployments.</li>
        </ul>
      `,
    },
  ],
};
